import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {GraphActionsService} from '../../../diagram-interaction/actions/graph-actions.service';
import {TranslateModule} from '@ngx-translate/core';
import {NgFor, NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-group-action-buttons',
  templateUrl: './group-action-buttons.component.html',
  styleUrls: ['./group-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    NgIf,
    TranslateModule
  ]
})
export class GroupActionButtonsComponent {
  constructor(private graphActionsSvc: GraphActionsService) {}

  @Input() canDoGroupActions;

  alignActions = [
    {svg: 'align-left', text: 'ALIGN_LEFT', param: 'left'},
    {svg: 'align-right', text: 'ALIGN_RIGHT', param: 'right'},
    {svg: 'align-top', text: 'ALIGN_TOP', param: 'top'},
    {svg: 'align-bottom', text: 'ALIGN_BOTTOM', param: 'bottom'},
    {svg: 'align-ver', text: 'ALIGN_HOR', param: 'horizontally'},
    {svg: 'align-hor', text: 'ALIGN_VER', param: 'vertically'},
    {svg: 'distribute-hor', text: 'DISTR_HOR', param: true, method: 'distributeCells'},
    {svg: 'distribute-ver', text: 'DISTR_VER', param: false, method: 'distributeCells'}
  ];

  sizingActions = [
    {svg: 'set-width', text: 'SET_WIDTH', param: [1, 0]},
    {svg: 'set-height', text: 'SET_HEIGHT', param: [0, 1]},
    {svg: 'set-w-h', text: 'SET_W_H', param: [1, 1]}
  ];

  alignAction(action) {
    if (action.method) {
      this.graphActionsSvc.distributeCells(action.param);
    } else {
      this.graphActionsSvc.alignCells(action.param);
    }
  }

  resizeCells(param) {
    return this.graphActionsSvc.setSimilarSize(param[0], param[1]);
  }
}
